//轮播面板箭头的line-height随着外框高度决定

function index() {
    $("#myCarousel").hammer().on('swipeleft', function() {
        $(this).carousel('next');
    });
    $("#myCarousel").hammer().on('swiperight', function() {
        $(this).carousel('prev');
    });
    loadUserInfo()
}

//节流函数，用于scroll resize事件
function throttle(method, context) {
    clearTimeout(method.tId);
    // console.log('cleat')
    method.tId = setTimeout(function() {
        method.call(context);
    }, 50);
}

function resizeCarouselControl() {
    var carouselHeight = $("#myCarousel .carousel-inner").width() / 3;
    $("#myCarousel .carousel-inner").height(carouselHeight);
    $("#myCarousel .carousel-control").css("line-height", carouselHeight + 'px');
}

function saveUser(user) {
     //uid, username, name, phone, email, token, subscribed, avatar
     window.name = JSON.stringify(user);
 }

function delCookie(name){
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval=getCookie(name);
    if(cval!=null)
    document.cookie= name + "="+cval+";expires="+exp.toGMTString()+"; path=/";
}

function loadUserInfo(){
    var info = getCookie('user-info');
    if(info){
        var unicode  = BASE64.decoder(info);
        var str = '';  
        for(var i = 0 , len =  unicode.length ; i < len ;++i){  
            str += String.fromCharCode(unicode[i]);  
        }
        var data = JSON.parse(str);
        var newtoken = data.token;
        var oldtoken = $.jStorage.get('localToken');
        var redirectURL = data.redirectURL;
        if(newtoken != oldtoken){
            delCookie('user-info')
            var tempToken = data["token"];
            var tempUsername = data["profile"]["username"];
            var tempTokenExpired = data["token_expired"];
            var tempSubscribe = data["profile"]["subscribed"];
            var tempEmail = data["profile"]["email"];
            var tempUid = data["profile"]["uid"];
            var tempName = data["profile"]["name"];
            var tempAvatar = data["profile"]["avatar"];
            var tempPhone = data["profile"]["phone"];
            $.jStorage.set("localToken", tempToken);
            $.jStorage.set("localUsername", tempUsername);
            $.jStorage.set("localSubscribe", tempSubscribe);
            $.jStorage.set("localEmail", tempEmail);
            $.jStorage.set("localUid", tempUid);
            $.jStorage.set("localName", tempName);
            $.jStorage.set("tempAvatar", tempAvatar);
            $.jStorage.set("tempPhone", tempPhone);

            saveUser({
                uid: tempUid,
                username: tempUsername,
                name: tempName,
                phone: tempPhone,
                email: tempEmail,
                token: tempToken,
                subscribed: tempSubscribe,
                avatar: tempAvatar
            })
            location.href = redirectURL ? redirectURL : "/";
            
        }else{
            delCookie('user-info')
            location.href = redirectURL ? redirectURL : "/";
        }        
    }
    
}